import { KYMW5400Model } from '../kymw5400.model';
import { GetCWSPlanGoodsSearchModel } from '../vo/get-cws-plan-goods-search.model';
import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 商品検索(5200流用)
 *
 * @export API通信成功時の処理
 * @class GetCategoryCandidacyGoodsInfoService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetCategoryCandidacyGoodsInfoService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel および Vo
  private model: KYMW5400Model = null;
  private vo: GetCWSPlanGoodsSearchModel = null;
  successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCodeListService
   */
  private getBody(): PlessRequest {
    let combinations = [];
    
    if (this.vo.pcodeList.length > 0) {
      // Pコードリスト検索
      this.vo.pcodeList.map((item) => {
        const addItem = {
          parameter: {
            Pcode: item,
            GoodsName: '',
            StandardName: '',
            CoopCode: '',
            TagId: '',
            MarkCode: '',
            CatalogCode: '',
            PageNo: '',
            ItemCode: '',
            Duties: '',
          }
        }
        combinations.push(addItem);
      })
    } 
    else if (this.vo.itemCodeList.length > 0) {
      // アイテムコードリスト検索
      this.vo.itemCodeList.map((item) => {
        const addItem = {
          parameter: {
            Pcode: '',
            GoodsName: '',
            StandardName: '',
            CoopCode: '',
            TagId: '',
            MarkCode: '',
            CatalogCode: '',
            PageNo: '',
            ItemCode: item,
            Duties: '',
          }
        }
        combinations.push(addItem);
      })
    } 
    else {
      const guideGoodsName = this.vo.guideGoodsNameList;
      const guideStandardName = this.vo.guideStandardNameList;
      const tagId = this.vo.tagIdList;
      const goodsMark = this.vo.goodsMarkList;
      const catalogCode = this.vo.catalogCodeList;
      const pageNo = this.vo.pageNoList;
      const coopCodeList = this.vo.coopCodeList;
      const dutiesList = this.vo.dutiesList;

      const maxLength = Math.max(guideGoodsName.length, guideStandardName.length, tagId.length, goodsMark.length,
        catalogCode.length, pageNo.length, coopCodeList.length, dutiesList.length);

      combinations = Array.from({ length: maxLength }, (_, index) => ({
        parameter: {
          Pcode: this.vo.pcode,
          GoodsName: guideGoodsName[index] !== undefined ? guideGoodsName[index] : '',
          StandardName: guideStandardName[index] !== undefined ? guideStandardName[index] : '',
          CoopCode: coopCodeList[index] !== undefined ? coopCodeList[index] : '',
          TagId: tagId[index] !== undefined ? tagId[index] : '',
          MarkCode: goodsMark[index] !== undefined ? goodsMark[index] : '',
          CatalogCode: catalogCode[index] != undefined ? catalogCode[index] : '',
          PageNo: pageNo[index] != undefined ? pageNo[index] : '',
          ItemCode: this.vo.itemCode,
          Duties: dutiesList[index] !== undefined ? dutiesList[index] : '',
        }
      }))
    }

    return new PlessRequest({
      search: {
        Rec: {
          parameter: {
            CategoryDiv: this.vo.categoryDiv,
            OrderCode: this.vo.orderCode,
            ItemCode: this.vo.itemCode,
            JANCode: this.vo.janCode,
            MakerName: this.vo.makerName,
            OrdrClientCode: this.vo.ordrClientCode,
            OrdrClientKanji: this.vo.ordrClientKanji,
            PayeeClientCode: this.vo.payeeClientCode,
            PayeeClientKanji: this.vo.payeeClientKanji,
            ClassCode: this.vo.classCode,
            MiddleClassCode: this.vo.middleClassCode,
            SmallClassCode: this.vo.smallClassCode,
            RegistDateFrom: this.vo.registDateFrom,
            RegistDateTo: this.vo.registDateTo,
            UpdateDateFrom: this.vo.updateDateFrom,
            UpdateDateTo: this.vo.updateDateTo,
            AdmitStatus: this.vo.admitStatus,
            BuyerCode: this.vo.buyerCode,
            PageNo: this.vo.pageNo,
            SortKey: this.vo.sortKey,
            SortOrder: this.vo.sortOrder,
            StockLimitFlg: this.vo.stockLimitFlg,
            TagSearchType: this.vo.tagSearchType,
            GoodsMarkSearchType: this.vo.goodsMarkSearchType,
            DataKbnFlg: this.vo.dataKbnFlg,
            GoodsDiv: this.vo.goodsDiv,
            SearchMediumType: this.vo.searchMediumType,
            SearchOrderCode: this.vo.searchOrderCode,
            SpecialFeature: this.vo.specialFeature,
            CatalogCodeSearchType: this.vo.catalogCodeSearchType,
          },
          combination: combinations
        }
      }
    })
  }


  /**
   * API呼び出し
   *
   * @param {CodeComboBoxModel} model
   * @param {string} codeDiv
   * @param {string} reserveNum1
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof GetCategoryCandidacyGoodsInfoService
   */
  execute(model: KYMW5400Model, vo: GetCWSPlanGoodsSearchModel, successFunc: Function = null) {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getCategoryCandidacyGoodsInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCategoryCandidacyGoodsInfoService
   */
  success(data: any) {
    if (this.successFunc !== null) {
      this.successFunc();
    }
    if (data !== null) {
      this.model.setSearchResult(data);
    }
  }
}
